import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  margin: 0 24px;
`;

export const SectionTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(12)}px;
`;

export const FieldHint = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  margin-bottom: ${RFValue(12)}px;
`;

export const MaxAmountCard = styled.View`
  flex-direction: row;
  align-items: flex-start;
  background-color: ${({theme}) => theme.colors.loan_otp_icon_bg};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(12)}px ${RFValue(14)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const MaxAmountIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.loan_otp_icon};
  margin-right: ${RFValue(10)}px;
  margin-top: ${RFValue(1)}px;
`;

export const MaxAmountText = styled.Text`
  flex: 1;
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.text_dark};
  line-height: ${RFValue(17)}px;
`;

export const AmountInput = styled.TextInput`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  padding-bottom: ${RFValue(12)}px;

  margin-bottom: ${RFValue(12)}px;
`;

export const AmountError = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.attention};
  margin-top: -${RFValue(10)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const OptionsLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(8)}px;
`;

export const PrazoInput = styled.TextInput`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.border};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const PrazoError = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.attention};
  margin-top: -${RFValue(10)}px;
  margin-bottom: ${RFValue(12)}px;
`;


export const InfoRow = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${RFValue(8)}px 0;
  margin-bottom: ${RFValue(12)}px;
`;

export const InfoRowLeft = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const InfoIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.title};
  margin-right: ${RFValue(8)}px;
`;

export const InfoTextBlock = styled.View``;

export const InfoTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const InfoValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};

`;

export const InfoChevron = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px ${RFValue(24)}px ${RFValue(16)}px;
`;

export const DetailsCard = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(18)}px;
  padding: ${RFValue(16)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  margin-bottom: ${RFValue(24)}px;
`;

export const DetailsTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(8)}px;
`;

export const DetailsText = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
  margin-bottom: ${RFValue(10)}px;
  line-height: ${RFValue(16)}px;
`;

